package team.platforma.materialextension.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.sp
import team.platforma.multiplatform_material_extension.tooltips.TooltipStyle

class TooltipTheme {
    @Composable
    fun light() {
        TooltipStyle.define(
            bgColor = Color.Gray,
            textStyle = TextStyle(color = Color.White, fontSize = 12.sp)
        )
    }

    @Composable
    fun dark() {
        TooltipStyle.define(
            bgColor = Color.White,
            textStyle = TextStyle(color = Color.Black, fontSize = 24.sp)
        )
    }

}